var clientsProducts  = {
    "3rpetroleum": {
        "Desk4me": true
    },
    "aditusbr": {
        "Desk4me": true
    },
    "aligntech": {
        "Desk4me": true,
        "Freeroom": true
    },
    "alperseguros": {
        "Desk4me": true
    },
    "andrademaia": {
        "Desk4me": true
    },
    "apsen": {
        "Freeroom": true
    },
    "aspenpharma": {
        "Freeroom": true,
        "Desk4me": true
    },
    "bancotoyota": {
        "Desk4me": true
    },
    "bicharalaw": {
        "Desk4me": true
    },
    "bmgseguros": {
        "Desk4me": true
    },
    "bpbungebio": {
        "Desk4me": true
    },
    "bradesco-plaza": {
        "Freeroom": true
    },
    "bslsaude": {
        "Freeroom": true
    },
    "buhlergroup": {
        "Desk4me": true
    },
    "buhlergroup-cz": {
        "Desk4me": true
    },
    "bunzl": {
        "Freeroom": true
    },
    "bvalaw": {
        "Freeroom": true
    },
    "careplus": {
        "Freeroom": true
    },
    "ccee": {
        "Desk4me": true,
        "Freeroom": true
    },
    "cea": {
        "Desk4me": true,
        "Freeroom": true
    },
    "cepeda": {
        "Desk4me": true
    },
    "ciandt": {
        "Desk4me": true,
        "Freeroom": true
    },
    "cidadematarazzo": {
        "Desk4me": true,
        "Freeroom": true
    },
    "cit": {
        "Desk4me": true,
        "Freeroom": true
    },
    "citbh": {
        "Desk4me": true
    },
    "clearsale": {
        "Desk4me": true,
        "Freeroom": true
    },
    "cmalaw": {
        "Desk4me": true
    },
    "cogna": {
        "Desk4me": true,
        "Freeroom": true
    },
    "conspiracao": {
        "Freeroom": true
    },
    "contaazul": {
        "Desk4me": true
    },
    "cordeirolima": {
        "Freeroom": true
    },
    "corning": {
        "Desk4me": true
    },
    "corteva": {
        "Desk4me": true,
        "Freeroom": true
    },
    "cpbgroup": {
        "Desk4me": true,
        "Freeroom": true
    },
    "cresol": {
        "Freeroom": true
    },
    "croda": {
        "Desk4me": true
    },
    "culturainglesa": {
        "Desk4me": true,
        "Freeroom": true
    },
    "cwosp": {
        "Desk4me": true
    },
    "default": {
        "Desk4me": true,
        "Freeroom": true
    },
    "dezker": {
        "Desk4me": true,
        "Freeroom": true
    },
    "diblasiparente": {
        "Desk4me": true
    },
    "digna": {
        "Freeroom": true
    },
    "diversey": {
        "Desk4me": true
    },
    "dojo": {
        "Desk4me": true
    },
    "dsbr": {
        "Desk4me": true,
        "Freeroom": true
    },
    "eagleburgmann": {
        "Desk4me": true
    },
    "ecoagro": {
        "Desk4me": true
    },
    "epiroc": {
        "Desk4me": true
    },
    "essilor": {
        "Desk4me": true
    },
    "essilorluxottica": {
        "Desk4me": true
    },
    "even": {
        "Desk4me": true
    },
    "fgc": {
        "Desk4me": true,
    },
    "fleury": {
        "Desk4me": true,
        "Freeroom": true
    },
    "fqbrasil": {
        "Desk4me": true,
        "Freeroom": true
    },
    "galapagosjogos": {
        "Desk4me": true
    },
    "gamaitaly": {
        "Desk4me": true
    },
    "garena": {
        "Desk4me": true
    },
    "greenpeace": {
        "Desk4me": true
    },
    "grupogr": {
        "Desk4me": true
    },
    "grupoinpress": {
        "Desk4me": true
    },
    "gruponos": {
        "Desk4me": true
    },
    "gruporihappy": {
        "Desk4me": true
    },
    "grupotapps": {
        "Desk4me": true
    },
    "grupotecnowise": {
        "Freeroom": true
    },
    "hash": {
        "Desk4me": true,
        "Freeroom": true
    },
    "hotmart": {
        "Desk4me": true,
        "Freeroom": true
    },
    "howdenharmonia": {
        "Desk4me": true
    },
    "icts": {
        "Desk4me": true,
        "Freeroom": true
    },
    "igua": {
        "Desk4me": true,
        "Freeroom": true
    },
    "ilegra": {
        "Desk4me": false,
        "Freeroom": true
    },
    "img": {
        "Desk4me": true,
        "Freeroom": true
    },
    "imggs": {
        "Desk4me": true,
        "Freeroom": true
    },
    "industriasantaluzia": {
        "Freeroom": true
    },
    "integraltrust": {
        "Desk4me": true
    },
    "intercement": {
        "Desk4me": true,
        "Freeroom": true
    },
    "interrs": {
        "Desk4me": true
    },
    "ipsosbr": {
        "Desk4me": true,
        "Freeroom": true
    },
    "italtelbrasil": {
        "Desk4me": true,
        "Freeroom": true
    },
    "lello": {
        "Desk4me": true,
        "Freeroom": true
    },
    "loccitane": {
        "Desk4me": true
    },
    "lockton": {
        "Desk4me": true
    },
    "lusobank": {
        "Freeroom": true
    },
    "mag": {
        "Desk4me": true,
        "Freeroom": true
    },
    "manuchar": {
        "Desk4me": true
    },
    "marinsbertoldi": {
        "Desk4me": true
    },
    "marfrig": {
        "Freeroom": true
    },
    "melhorenvio": {
        "Desk4me": true
    },
    "mercafacil": {
        "Desk4me": true
    },
    "mosaico": {
        "Desk4me": true
    },
    "mrologistics": {
        "Desk4me": true
    },
    "negociospublicos": {
        "Desk4me": true
    },
    "neowrk": {
        "Desk4me": true
    },
    "netglobe": {
        "Freeroom": true
    },
    "nimbi": {
        "Desk4me": true
    },
    "nsk": {
        "Freeroom": true
    },
    "orama": {
        "Desk4me": false,
        "Freeroom": true
    },
    "orpea": {
        "Freeroom": true
    },
    "ourofinoagro": {
        "Freeroom": true
    },
    "panasonic": {
        "Desk4me": true,
        "Freeroom": true
    },
    "petrobras": {
        "Desk4me": true,
        "Freeroom": true
    },
    "petrobras-bo": {
        "Desk4me": true,
        "Freeroom": true
    },
    "petrobras-treinamento": {
        "Desk4me": true
    },
    "suportepetrobras": {
        "Desk4me": true,
        "Freeroom": true
    },
    "suportepetrobras-bo": {
        "Desk4me": true,
        "Freeroom": true
    },
    "pladvogados": {
        "Desk4me": true
    },
    "planopasa": {
        "Desk4me": true,
        "Freeroom": true
    },
    "portoseguro": {
        "Desk4me": true,
        "Freeroom": true
    },
    "suporteportoseguro": {
        "Desk4me": true,
        "Freeroom": true
    },
    "promon": {
        "Desk4me": true,
        "Freeroom": true
    },
    "protcap": {
        "Freeroom": true
    },
    "rigarr": {
        "Freeroom": true
    },
    "rodobens": {
        "Desk4me": true,
        "Freeroom": true
    },
    "sankhya": {
        "Desk4me": true
    },
    "santistasa": {
        "Desk4me": true
    },
    "sapura": {
        "Freeroom": true
    },
    "sempreengenharia": {
        "Freeroom": true
    },
    "senior": {
        "Desk4me": true
    },
    "shopee": {
        "Desk4me": true
    },
    "shpl": {
        "Desk4me": true
    },
    "siemensgamesa": {
        "Desk4me": true
    },
    "sodexobeneficios": {
        "Desk4me": true,
        "Freeroom": true
    },
    "sodexoonsite": {
        "Desk4me": true
    },
    "suportesodexoonsite": {
        "Desk4me": true,
        "Freeroom": true
    },
    "solfacil": {
        "Desk4me": true,
        "Freeroom": true
    },
    "sotreq": {
        "Desk4me": true,
        "Freeroom": false
    },
    "stage-desk4me": {
        "Desk4me": true,
        "Freeroom": false
    },
    "stage-freeroom": {
        "Desk4me": false,
        "Freeroom": true
    },
    "stoller": {
        "Freeroom": true
    },
    "strattner": {
        "Desk4me": true
    },
    "synergia": {
        "Desk4me": true
    },
    "tecnobank": {
        "Desk4me": true
    },
    "tetrapak": {
        "Desk4me": true
    },
    "suportetetrapak": {
        "Desk4me": true
    },
    "tirolez": {
        "Desk4me": true
    },
    "tpv": {
        "Desk4me": true
    },
    "valia": {
        "Desk4me": true
    },
    "vedacit": {
        "Freeroom": true
    },
    "vernalhapereira": {
        "Desk4me": true
    },
    "vissimo": {
        "Desk4me": true,
        "Freeroom": true
    },
    "vivest": {
        "Desk4me": true
    },
    "wavin": {
        "Desk4me": true
    },
    "youinc": {
        "Freeroom": true
    },
    "yusen-logistics": {
        "Desk4me": true
    }
}

var getClientObject = function (){
    let clientProduct = clientsProducts[window.location.host.substring(0, window.location.host.indexOf('.neowrk'))]
    return clientProduct ? clientProduct : clientsProducts['default']
}

var checkifHasMoreThanOneProduct = function () {
    let hasOne = false
    let hasTwo = false
    let clientProducts = getClientObject()
    Object.keys(clientProducts).forEach(key => {
        if(clientProducts[key]){
            if(hasOne){
                hasTwo = true
            } else {
                hasOne = true
            }
        }
    })
    return hasTwo
}

module.exports = { clientsProducts, getClientObject, checkifHasMoreThanOneProduct }